export default async function saveToLocalStorage<V>(
  key: string,
  value: V,
): Promise<void> {
  return localStorage.setItem(key, JSON.stringify(value));
}
